/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import Seccion_Home from "./Secciones/Seccion_Home";
import Footer from "./Footer";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Detalle from "./Secciones/Seccion_Detalle";

const Pagina = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <h1 style={{display: 'none'}}>Spa Lodge Ecuador</h1>

            <h2 style={{display: 'none'}}>lodge naturaleza cerca de Quito</h2>
            <h2 style={{display: 'none'}}>ecoturismo en Ecuador</h2>
            <h2 style={{display: 'none'}}>cabañas en la naturaleza Ecuador</h2>
            <h2 style={{display: 'none'}}>alojamiento ecológico cerca de Quito</h2>

            <Router>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                <Barra/>
            </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Suite/:id"} element={<Seccion_Detalle/>}/>
                    </Routes>
                </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Footer/>
            </Grid>

            </Router>

        </Grid>
    )

}
export default Pagina